"use strict";
/**
 * Started-play detection for EventScores — used by CreateEventScores merge/cleanup
 * and live-scoring first-tee flows.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.liveScoringRoundStarted = liveScoringRoundStarted;
exports.eventScoreHasStartedPlay = eventScoreHasStartedPlay;
exports.classifyOrphanEventScores = classifyOrphanEventScores;
function liveScoringRoundStarted(roundScore, scoreType) {
    if (!roundScore)
        return false;
    if (roundScore.submitted === true)
        return true;
    if (roundScore.confirmedAt !== null && roundScore.confirmedAt !== undefined)
        return true;
    const opponent = String(scoreType ?? '').toLowerCase() === 'opponent';
    return (roundScore.holeScores?.some((h) => {
        if ((h.playerScore ?? 0) > 0)
            return true;
        if (opponent && (h.markerScore ?? 0) > 0)
            return true;
        return false;
    }) ?? false);
}
/** True when any round on the document has started play. */
function eventScoreHasStartedPlay(score, scoreType) {
    return (score?.roundScores ?? []).some((rs) => liveScoringRoundStarted(rs, scoreType));
}
/**
 * Classify existing EventScores absent from the incoming CreateEventScores payload.
 * Unstarted orphans are safe to delete; started orphans are retained for history.
 */
function classifyOrphanEventScores(existingScores, incomingPlayerScoreCodes, scoreType) {
    const incoming = new Set(incomingPlayerScoreCodes);
    const orphanCandidates = existingScores.filter((s) => !incoming.has(s.playerScoreCode));
    const toDeleteIds = orphanCandidates
        .filter((s) => !eventScoreHasStartedPlay(s, scoreType))
        .map((s) => s._id);
    return {
        toDeleteIds,
        deletedOrphanCount: toDeleteIds.length,
        retainedOrphanCount: orphanCandidates.length - toDeleteIds.length,
    };
}
